// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/physics.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../images/chemistry.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../images/zoology.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../images/botnay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../images/maths.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.physics_img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.chemistry_img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.zoology_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.botnay_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.maths_img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.learn_practice .learn-card-status {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
}
.learn_practice .weekselection {
  width: 150px;
}
.learn_practice a {
  text-decoration: none;
}
.learn_practice a .singlecard {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1rem;
}
.learn_practice a .singlecard .bg-img {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  filter: blur(2px);
}
.learn_practice a .singlecard .bg-img::before {
  background: hsla(0, 0%, 0%, 0.7);
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  border-radius: 8px;
  z-index: 1;
}
.learn_practice a .singlecard .card-header {
  position: relative;
  border-radius: 8px;
}
.learn_practice a .singlecard .card-header .content {
  color: #ffffff;
  position: relative;
  border-bottom: 1px solid #696969;
  z-index: 2;
}
.learn_practice a .singlecard .card-header .content .icon {
  text-align: center;
  display: block;
  line-height: 80px;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  background: hsla(0, 0%, 0%, 0.42);
  color: #ffffff;
}
.learn_practice a .singlecard .card-header .content .icon svg {
  height: 50px;
}
.learn_practice a .singlecard .card-body {
  position: relative;
}
.learn_practice a .singlecard .card-body .snv,
.learn_practice a .singlecard .card-body .rm {
  position: relative;
  font-size: 16px;
  color: #ffffff;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/_learnpractice.scss"],"names":[],"mappings":"AAAA;EACI,yDAAA;AACJ;;AAEA;EACI,yDAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAKI;EACI,oDAAA;AAFR;AAKI;EACI,YAAA;AAHR;AAMI;EACI,qBAAA;AAJR;AAMQ;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,mBAAA;AALZ;AAOY;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iBAAA;AALhB;AAOgB;EACI,gCAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AALpB;AASY;EACI,kBAAA;EACA,kBAAA;AAPhB;AASgB;EACI,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;AAPpB;AASoB;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;AAPxB;AASwB;EACI,YAAA;AAP5B;AAaY;EACI,kBAAA;AAXhB;AAagB;;EAEI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AAXpB","sourcesContent":[".physics_img {\n    background-image: url('../../../images/physics.png');\n}\n\n.chemistry_img {\n    background-image: url('../../../images/chemistry.png');\n}\n\n.zoology_img {\n    background: url('../../../images/zoology.png');\n}\n\n.botnay_img {\n    background: url('../../../images/botnay.png');\n}\n\n.maths_img {\n    background: url('../../../images/maths.png');\n}\n\n\n\n.learn_practice {\n    .learn-card-status {\n        box-shadow: 0px 3px 10px #0000000D;\n    }\n\n    .weekselection {\n        width: 150px;\n    }\n\n    a {\n        text-decoration: none;\n\n        .singlecard {\n            position: relative;\n            border-radius: 8px;\n            overflow: hidden;\n            // flex-direction: row;\n            margin-bottom: 1rem;\n\n            .bg-img {\n                left: 0;\n                top: 0;\n                width: 100%;\n                height: 100%;\n                content: '';\n                position: absolute;\n                z-index: 1;\n                background-size: cover;\n                background-position: top center;\n                background-repeat: no-repeat;\n                filter: blur(2px);\n\n                &::before {\n                    background: hsla(0, 0%, 0%, 0.7);\n                    left: 0;\n                    top: 0;\n                    width: 100%;\n                    height: 100%;\n                    content: '';\n                    position: absolute;\n                    border-radius: 8px;\n                    z-index: 1;\n                }\n            }\n\n            .card-header {\n                position: relative;\n                border-radius: 8px;\n\n                .content {\n                    color: #ffffff;\n                    position: relative;\n                    border-bottom: 1px solid #696969;\n                    z-index: 2;\n\n                    .icon {\n                        text-align: center;\n                        display: block;\n                        line-height: 80px;\n                        width: 80px;\n                        height: 80px;\n                        border-radius: 4px;\n                        background: hsla(0, 0%, 0%, 0.42);\n                        color: #ffffff;\n\n                        svg {\n                            height: 50px;\n                        }\n                    }\n                }\n            }\n\n            .card-body {\n                position: relative;\n\n                .snv,\n                .rm {\n                    position: relative;\n                    font-size: 16px;\n                    color: #ffffff;\n                    z-index: 2;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
